module.exports = __webpack_public_path__ + "img/paydone-light.4b83ef24.png";